import {
    GET_ROLEPERMISSION,
    EDIT_ROLEPERMISSION,
    ALL_ROLEPERMISSION
  } from "./actionTypes"

  export const allRolePermissions = role => {
    return {
      type: ALL_ROLEPERMISSION,
      payload: role,
    }
  }


  export const getRolePermissions = (role) => {
    return {
      type: GET_ROLEPERMISSION,
      payload: { role},
    }
  }

  export const editRolePermissions =  (rolePermission,history) => {
    return {
      type: EDIT_ROLEPERMISSION,
      payload: { rolePermission,history},
    }
  }